import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "c-eyecatch c-eyecatch--profile" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "c-eyecatch__img" })
], -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { class: "p-mypage__ttl c-ttl" }, "会員情報 確認", -1)
const _hoisted_3 = { class: "p-mypage__sec" }
const _hoisted_4 = { class: "p-mypage__field-container" }
const _hoisted_5 = {
  key: 0,
  class: "p-errors"
}
const _hoisted_6 = { class: "c-error" }
const _hoisted_7 = { class: "p-fields p-fields--confirm" }
const _hoisted_8 = { class: "c-field" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "c-field__label" }, "プロフィール画像", -1)
const _hoisted_10 = { class: "c-field__body" }
const _hoisted_11 = { class: "upload-img" }
const _hoisted_12 = ["src"]
const _hoisted_13 = { class: "c-field" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "c-field__label" }, "お名前", -1)
const _hoisted_15 = { class: "c-field__body" }
const _hoisted_16 = { class: "c-field" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "c-field__label" }, "ふりがな", -1)
const _hoisted_18 = { class: "c-field__body" }
const _hoisted_19 = { class: "c-field" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "c-field__label" }, "ニックネーム", -1)
const _hoisted_21 = { class: "c-field__body" }
const _hoisted_22 = { class: "c-field" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "c-field__label" }, "性別", -1)
const _hoisted_24 = { class: "c-field__body" }
const _hoisted_25 = { class: "c-field" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "c-field__label" }, "誕生日", -1)
const _hoisted_27 = { class: "c-field__body" }
const _hoisted_28 = { class: "c-field" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", { class: "c-field__label" }, "結婚の有無", -1)
const _hoisted_30 = { class: "c-field__body" }
const _hoisted_31 = { class: "c-field" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { class: "c-field__label" }, "子供の有無", -1)
const _hoisted_33 = { class: "c-field__body" }
const _hoisted_34 = { class: "c-field" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("div", { class: "c-field__label" }, "血液型", -1)
const _hoisted_36 = { class: "c-field__body" }
const _hoisted_37 = { class: "c-field" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("div", { class: "c-field__label" }, "郵便番号", -1)
const _hoisted_39 = { class: "c-field__body" }
const _hoisted_40 = { class: "c-field" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("div", { class: "c-field__label" }, "都道府県", -1)
const _hoisted_42 = { class: "c-field__body" }
const _hoisted_43 = { class: "c-field" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("div", { class: "c-field__label" }, "住所", -1)
const _hoisted_45 = { class: "c-field__body" }
const _hoisted_46 = { class: "c-field" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("div", { class: "c-field__label" }, "電話番号", -1)
const _hoisted_48 = { class: "c-field__body" }
const _hoisted_49 = { class: "c-field has-submit has-mt" }
const _hoisted_50 = ["disabled"]
const _hoisted_51 = /*#__PURE__*/_createElementVNode("span", null, "更新する", -1)
const _hoisted_52 = [
  _hoisted_51
]
const _hoisted_53 = ["disabled"]
const _hoisted_54 = /*#__PURE__*/_createElementVNode("span", null, "編集画面に戻る", -1)
const _hoisted_55 = [
  _hoisted_54
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _hoisted_2,
    _createElementVNode("section", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        (_ctx.errorMsgRef)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.errorMsgRef), 1)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("fieldset", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("p", null, [
                _createElementVNode("span", _hoisted_11, [
                  _createElementVNode("img", {
                    src: _ctx.image.path ? _ctx.image.path : require('@/assets/images/common/img_user-default.svg'),
                    alt: "Upload image"
                  }, null, 8, _hoisted_12)
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _hoisted_14,
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("p", null, [
                _createElementVNode("span", null, _toDisplayString(_ctx.userBase.baseInfo.lastName), 1),
                _createElementVNode("span", null, _toDisplayString(_ctx.userBase.baseInfo.firstName), 1)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _hoisted_17,
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("p", null, [
                _createElementVNode("span", null, _toDisplayString(_ctx.userBase.baseInfo.lastKana), 1),
                _createElementVNode("span", null, _toDisplayString(_ctx.userBase.baseInfo.firstKana), 1)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_19, [
            _hoisted_20,
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("p", null, _toDisplayString(_ctx.nickName), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_22, [
            _hoisted_23,
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("p", null, _toDisplayString(_ctx.userBase.commonAttrInfo.gender === "無回答" ? "回答しない" :  _ctx.userBase.commonAttrInfo.gender), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_25, [
            _hoisted_26,
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("p", null, [
                _createElementVNode("span", null, _toDisplayString(isNaN(_ctx.date.year) ? "" : _ctx.date.year + "年"), 1),
                _createElementVNode("span", null, _toDisplayString(isNaN(_ctx.date.month) ? "" : _ctx.date.month + "月"), 1),
                _createElementVNode("span", null, _toDisplayString(isNaN(_ctx.date.day) ? "" : _ctx.date.day + "日"), 1)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_28, [
            _hoisted_29,
            _createElementVNode("div", _hoisted_30, [
              _createElementVNode("p", null, _toDisplayString((_ctx.userBase.commonAttrInfo.isMarried === null) ? "" : (_ctx.userBase.commonAttrInfo.isMarried) ? "既婚" : "未婚"), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_31, [
            _hoisted_32,
            _createElementVNode("div", _hoisted_33, [
              _createElementVNode("p", null, _toDisplayString((_ctx.userBase.commonAttrInfo.hasChild === null) ? "" : (_ctx.userBase.commonAttrInfo.hasChild) ? "有り" : "無し"), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_34, [
            _hoisted_35,
            _createElementVNode("div", _hoisted_36, [
              _createElementVNode("p", null, _toDisplayString((_ctx.userBase.commonAttrInfo.bloodType === null || _ctx.userBase.commonAttrInfo.bloodType === "") ? "" : (_ctx.userBase.commonAttrInfo.bloodType === "不明") ? "不明" : _ctx.userBase.commonAttrInfo.bloodType + "型"), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_37, [
            _hoisted_38,
            _createElementVNode("div", _hoisted_39, [
              _createElementVNode("p", null, _toDisplayString(_ctx.userBase.baseInfo.zipCode), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_40, [
            _hoisted_41,
            _createElementVNode("div", _hoisted_42, [
              _createElementVNode("p", null, _toDisplayString(_ctx.userBase.baseInfo.prefecture), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_43, [
            _hoisted_44,
            _createElementVNode("div", _hoisted_45, [
              _createElementVNode("p", null, [
                _createElementVNode("span", null, _toDisplayString(_ctx.userBase.baseInfo.address), 1),
                _createElementVNode("span", null, _toDisplayString(_ctx.userBase.baseInfo.building), 1)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_46, [
            _hoisted_47,
            _createElementVNode("div", _hoisted_48, [
              _createElementVNode("p", null, _toDisplayString(_ctx.userBase.baseInfo.tel), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_49, [
            _createElementVNode("button", {
              type: "button",
              class: "c-btn is-submit",
              disabled: _ctx.isDeterringRef,
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.asyncDeterringWrap(_ctx.update, this)))
            }, _hoisted_52, 8, _hoisted_50),
            _createElementVNode("button", {
              type: "button",
              class: "c-btn c-btn--outline",
              disabled: _ctx.isDeterringRef,
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.cancel && _ctx.cancel(...args)))
            }, _hoisted_55, 8, _hoisted_53)
          ])
        ])
      ])
    ])
  ], 64))
}